import { Button, Grid, Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import { useTheme } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import LabelsContext from "../../../lang/LabelsContext";
import ArticleCard from "../article-card/ArticleCard";
import ToDoListService, { ToDoListServiceType } from "./ReviewerToDoListService";
import useStyles from "./ReviewerToDoListStyle";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function ReviewerToDoList() {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const { Labels } = LabelsContext();
  const [value, setValue] = useState(0);
  const { pendingList, decideList, postAcceptDeclineArticle }: ToDoListServiceType = ToDoListService();
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const rightButtonsReq = (article: any) => {
    return (
      <Grid container spacing={1}>
        <Grid item>
          <Button
            variant="outlined"
            size="small"
            color="primary"
            onClick={() => {
              postAcceptDeclineArticle(article?.id, article?.articleReviewer?.id, true);
            }}
          >
            {Labels.ACCEPT}
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="outlined"
            size="small"
            color="primary"
            onClick={() => {
              postAcceptDeclineArticle(article?.id, article?.articleReviewer?.id, false);
            }}
          >
            {Labels.DECLINE}
          </Button>
        </Grid>
      </Grid>
    );
  };
  const rightButtonsPen = (article: any) => {
    return (
      <Grid container spacing={1}>
        <Grid item>
          <Button
            variant="outlined"
            size="small"
            color="primary"
            onClick={() => history.push(`/${article?.id}/review/${article?.articleReviewer?.id}`)}
          >
            {Labels.REVIEW}
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <div className={classes.root}>
      <Typography variant="h5">{Labels.TO_DO_LIST}</Typography>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label={`${Labels.REVIEW_REQUESTS} (${decideList?.length ?? 0})`} {...a11yProps(0)} />
          <Tab label={`${Labels.PENDING_REVIEWS} (${pendingList?.length ?? 0})`} {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} dir={theme.direction}>
        <Grid container direction="row" justifyContent="flex-start" spacing={3}>
          {decideList?.map((article: any) => (
            <Grid item xs={12} sm={12}>
              <ArticleCard
                data={article}
                index={0}
                rightComponent={() => rightButtonsReq(article)}
                animation={true}
                linkDisable={true}
              />
            </Grid>
          ))}
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={1} dir={theme.direction}>
        <Grid container direction="row" justifyContent="flex-start" spacing={3}>
          {pendingList?.map((article: any) => (
            <Grid item xs={12} sm={12}>
              <ArticleCard
                data={article}
                index={0}
                rightComponent={() => rightButtonsPen(article)}
                animation={true}
                linkDisable={true}
              />
            </Grid>
          ))}
        </Grid>
      </TabPanel>
    </div>
  );
}
